<template>
  <div class="p" style="background-color:#ffffff; border-radius: 20px;">

    <vue-element-loading :active="cargando" spinner="bar-fade-scale" color="#064dc3" size="120" :is-full-screen="true" text="Cargando..."/>
      <div class="form-row">
        <h1 class="col-9">Reporte de Kilometros recorridos por unidad</h1>
        <div class="col-2">
        </div>
        <router-link to="/home">
          <b-button variant="outline-success" style="margin: 10px">
            <div class="h6 mb-1">
              <b-icon-arrow-left-square></b-icon-arrow-left-square>
            </div>
            <div style="font-size: 12px;">
              Inicio
            </div>
          </b-button>
        </router-link>
      </div>
    
  
    <div class="row">
      <div class="col-12">
        <label class="col-form-label">Unidades</label>
        <multiselect ref="select" v-model="dispositivosSeleccionados" placeholder="Seleccione los dispositivos" label="name" track-by="id" :options="dispositivosObtenidos" :multiple="true" :hide-selected="true" select-label="Seleccionar" deselect-label="Remover">
        </multiselect>
        <button class="btn btn-sm btn-outline-primary mt-1" @click="selectAll">Select todo</button>
        <button class="btn btn-sm btn-outline-primary mt-1 ml-2" @click="removeAll">Limpiar</button>
      </div>
      <div class="col-12">
        <label class="col-form-label">Grupos</label>
        <multiselect ref="select" v-model="gruposSeleccionados" placeholder="Seleccione los dispositivos" label="name" track-by="id" :options="gruposObtenidos" :multiple="true" :hide-selected="true" select-label="Seleccionar" deselect-label="Remover">
        </multiselect>
        <button class="btn btn-sm btn-outline-primary mt-1" @click="selectAllGrupos">Select todo</button>
        <button class="btn btn-sm btn-outline-primary mt-1 ml-2" @click="removeAllGrupos">Limpiar</button>
      </div>
      <div class="col-md-4 mt-4">
        <input type="date" class="form-control" v-model="fechaInicio">
      </div>
      <div class="col-md-2 mt-4">
        <input type="time" class="form-control" v-model="horaInicio">
      </div>
      <div class="col-md-4 mt-4">
        <input type="date" class="form-control" v-model="fechaFin">
      </div>
      <div class="col-md-2 mt-4">
        <input type="time" class="form-control" v-model="horaFin">
      </div>
    </div>
    <button class="btn btn-sm btn-primary mt-3" @click="generarReporte()">Generar reporte</button>
    <button class="btn btn-sm btn-primary mt-3 ml-2" @click="exportExcel()">Exportar Excel</button>
    <button class="btn btn-sm btn-primary mt-3 ml-2" @click="exportCSV()">Exportar CSV</button>
    <div class="table-responsive mt-4">
      <table class="table table-bordered table-hover text-center">
        <thead style="background-color: #05123C;">
          <tr class="text-white">
            <th>Unidad</th>
            <th>Distancia</th>
            <th>Odómetro inicial</th>
            <th>Odómetro final</th>
            <th>Velocidad promedio</th>
            <th>Velocidad máxima</th>
            <!-- <th>Horas motor</th> -->
            <!-- <th>Combustible utilizado</th> -->
          </tr>
        </thead>
        <tbody>
          <tr v-for="item of formatearDatos">
            <td>{{ item.deviceName }}</td>
            <td>{{ item.distance }} km</td>
            <td>{{ item.startOdometer }} km</td>
            <td>{{ item.endOdometer }} km</td>
            <td>{{ item.averageSpeed }} km/h</td>
            <td>{{ item.maxSpeed }} km/h</td>
            <!-- <td>{{ item.engineHours }}</td> -->
            <!-- <td>{{ item.spentFuel }}</td> -->
          </tr>
        </tbody>
      </table>
    </div>

  </div>
</template>


<script>

/*
if (localStorage.length > 0) {
  var dataSesion = localStorage.setItem("Sesionn", JSON.stringify(dataSesion));
  var dataFromlocal = JSON.parse(localStorage.getItem("Sesionn"));
var dataFromlocalStorageeeee = JSON.parse(localStorage.getItem("Sesionn"));
console.log(dataFromlocalStorageeeee);
console.log(dataFromlocalStorageeeee);

var email = dataFromlocalStorageeeee.email;
var password = dataFromlocalStorageeeee.pass;

var email = dataFromlocal.email;
var password = dataFromlocal.pass;
var email = sessionStorage.getItem('emaill');
var password = sessionStorage.getItem('passwordd');
 //...
 } else {
   */

 //...
 




import { mapState, mapMutations, mapActions } from "vuex";
//import {mostrarMensajeErrorCatch, mostrarMensajeInformativo, mostrarMensajeExitoso, mostrarMensajeError} from '../../mixins/mensajes';

export default {
  data() {
    return {
      dispositivosObtenidos: [],
      dispositivosSeleccionados: [],
      gruposObtenidos: [],
      gruposSeleccionados: [],
      geocercasObtenidas: [],
      fechaInicio: '',
      horaInicio: '00:00',
      fechaFin: '',
      horaFin: '00:00',
      datosReporte: []
    }
  },
  watch: {
    dispositivosSeleccionados(newSelected) {
  
     
      this.dispositivosSeleccionados = newSelected;
      
    },
    gruposSeleccionados(newSelected) {
  
     
  this.gruposSeleccionados = newSelected;

}
  },

  computed: {
    ...mapState({
      catUnidades: state => state.catalogos.catUnidades
    }),

    ...mapState(["cargando"]),

    formatearIds() {
      let data = '';
      var index = 0;
      for (let item of this.dispositivosSeleccionados) {
        (index == 0) ? data += 'deviceId=' + item.id : data += '&deviceId=' + item.id;
        index++;
      }
      return data;
    },

    formatearIdGrupo() {
      let data = '';
      var index = 0;
      for (let item of this.gruposSeleccionados) {
        (index == 0) ? data += 'groupId=' + item.id : data += '&groupId=' + item.id;
        index++;
      }
      return data;
    },


    formatearDatos() {
      var index = 0;
      for (let item of this.datosReporte) {
        item.distance = (item.distance/1000).toFixed(2);
        item.startOdometer = (item.startOdometer/1000).toFixed(2);
        item.endOdometer = (item.endOdometer/1000).toFixed(2);
        item.averageSpeed = (item.averageSpeed*1.852).toFixed(1);
        item.maxSpeed = (item.maxSpeed*1.852).toFixed(1);
        index++;
      }
      console.log(this.dispositivosSeleccionados);
      return this.datosReporte;
    }
  },

  methods: {
    ...mapActions("catalogos", ["obtenerUnidades"]),
    ...mapMutations(["setearCargando"]),

    obtenerSesion() {
      let params = new URLSearchParams();
      params.append("email", "desarrollo.gps@busmen.com");
      params.append("password", "12345");
      let headers = { headers: { "Content-Type": "application/x-www-form-urlencoded" } };

      axios.post(`${url}session`, params, headers)
        .then(response => {
          console.log("Sesion");
        })
        .catch(error => {
          console.log("No sesion");
        });
    },

    generarReporte() {
      if (this.fechaInicio !='' & this.fechaFin.length !='') {
        if(this.dispositivosSeleccionados.length || this.gruposSeleccionados.length){
          let fechaInicio = encodeURIComponent( new Date(this.fechaInicio + ' ' + this.horaInicio).toISOString().split('.')[0]+"Z" );
        let fechaFin = encodeURIComponent( new Date(this.fechaFin + ' ' + this.horaFin).toISOString().split('.')[0]+"Z" );

        this.setearCargando(true);
        if (this.gruposSeleccionados.length) {
          this.reporteGrupos(fechaInicio, fechaFin);
        }else{
          this.reporteDispositivos(fechaInicio, fechaFin);
        }

        }else{
          alert('Debe seleccionar ya sean grupos o unidades');

        }


        


      }else if (this.fechaInicio =='' & this.fechaFin.length =='' & this.gruposSeleccionados == '' & this.dispositivosSeleccionados == '')
      {
        alert('Debe seleccionar las fechas y unidades o grupos');
      }
       else if (this.gruposSeleccionados == '' & this.dispositivosSeleccionados == '')
      {
        alert('Debe seleccionar ya sean grupos o unidades');
      }
      else if (this.fechaInicio ==''  & this.fechaFin.length =='')
      {
        alert('Debe seleccionar las fechas');
      }
    },

    reporteDispositivos(fechaInicio, fechaFin){
      axios.get(`${url}reports/summary?${this.formatearIds}&from=${fechaInicio}&to=${fechaFin}` , JSON.parse(localStorage.user))
        .then(response => {
          this.datosReporte = response.data;
          this.setearCargando(false);
        })
        .catch(error => {
          alert('Ha ocurrido un error');
          this.setearCargando(false);
        });
    },

    reporteGrupos(fechaInicio, fechaFin){
      axios.get(`${url}reports/summary?${this.formatearIdGrupo}&from=${fechaInicio}&to=${fechaFin}` , JSON.parse(localStorage.user))
        .then(response => {
          this.datosReporte = response.data;
          this.setearCargando(false);
        })
        .catch(error => {
          this.setearCargando(false);
          alert('Ha ocurrido un error');
        });
    },

    selectAll() {
      this.dispositivosSeleccionados = [];
      for (let item of this.dispositivosObtenidos) {
          this.dispositivosSeleccionados.push(item);
      }
    },
    
    selectAllGrupos() {
      this.gruposSeleccionados = [];
      for (let item of this.gruposObtenidos) {
          this.gruposSeleccionados.push(item);
      }
    },

    removeAll() {
      this.dispositivosSeleccionados = [];
    },
    
    removeAllGrupos() {
      this.gruposSeleccionados = [];
    },

    exportExcel() {
			if(this.datosReporte){
        let data = XLSX.utils.json_to_sheet(this.datosReporte, { header: ['deviceId', 'deviceName', 'distance', 'averageSpeed', 'maxSpeed', 'startOdometer', 'endOdometer'] } );
        data['A1'].v = 'id';
        data['B1'].v = 'dispositivo';
        data['C1'].v = 'distancia';
        data['D1'].v = 'velocidadPromedio';
        data['E1'].v = 'velocidadMaxima';
        data['F1'].v = 'odometroInicial';
        data['G1'].v = 'odometroFinal';

				const workbook = XLSX.utils.book_new();
				const filename = 'Reporte';
				XLSX.utils.book_append_sheet(workbook, data, filename);
      //  XLSX.writeFile(workbook, `${filename}${this.fechaInicio} ${this.horaInicio} - ${this.fechaFin} ${this.horaFin}.csv`);
        XLSX.writeFile(workbook, `${filename}${this.fechaInicio} ${this.horaInicio} - ${this.fechaFin} ${this.horaFin}.xlsx`);
			}
			else{
				alert('Ha ocurrido un error');
      }
    },
    exportCSV() {
			if(this.datosReporte){
        let data = XLSX.utils.json_to_sheet(this.datosReporte, { header: ['deviceId', 'deviceName', 'distance', 'averageSpeed', 'maxSpeed', 'startOdometer', 'endOdometer'] } );
        data['A1'].v = 'id';
        data['B1'].v = 'dispositivo';
        data['C1'].v = 'distancia';
        data['D1'].v = 'velocidadPromedio';
        data['E1'].v = 'velocidadMaxima';
        data['F1'].v = 'odometroInicial';
        data['G1'].v = 'odometroFinal';

				const workbook = XLSX.utils.book_new();
				const filename = 'Reporte';
				XLSX.utils.book_append_sheet(workbook, data, filename);
        XLSX.writeFile(workbook, `${filename}${this.fechaInicio} ${this.horaInicio} - ${this.fechaFin} ${this.horaFin}.csv`);
      //  XLSX.writeFile(workbook, `${filename}${this.fechaInicio} ${this.horaInicio} - ${this.fechaFin} ${this.horaFin}.xlsx`);
			}
			else{
				alert('Ha ocurrido un error');
      }
    },

    obtenertoken() {
      
    },

    obtenerDispositivos() {
      
      this.setearCargando(true);
      axios.get(`${url}devices`, JSON.parse(localStorage.user))
        .then(response => {
          this.dispositivosObtenidos = response.data;
          this.setearCargando(false);
        })
        .catch(error => {
          this.setearCargando(false);
          alert('Ha ocurrido un error');
        }); 

    },


    obtenerGrupos() {
      
      this.setearCargando(true);
      axios.get(`${url}groups`, JSON.parse(localStorage.user))
        .then(response => {
          this.gruposObtenidos = response.data;
          this.setearCargando(false);
        })
        .catch(error => {
          this.setearCargando(false);
          alert('Ha ocurrido un error');

        });
    },
    
     obtenerGeocercas() {
      this.setearCargando(true);
      axios.get(`${url}geofences`, JSON.parse(localStorage.user))
        .then(response => {
          this.geocercasObtenidas = response.data;
          this.setearCargando(false);
        })
        .catch(error => {
          this.setearCargando(false);
          alert('Ha ocurrido un error');

        });
    },
  },

  created() {
    this.obtenerDispositivos();
    this.obtenerGrupos();
    this.obtenerGeocercas();
    // this.obtenerUnidades();
    // this.obtenerSesion();
  },

  mounted() {
    // this.obtenerKilometraje();
    console.log(sessionStorage.aleatorio);
    if (sessionStorage.aleatorio != 1379248){
    this.$router.push({name: "/" });
  }
  }
}
</script>
<style>
  .p{
    margin: 50px;
    margin-bottom:1%;
    padding-right: 15px;
    padding-left: 15px;
    padding-bottom: 15px;
    padding-top:15px;
  }
</style>